import { render } from "./Ticket_Lifecycle.vue?vue&type=template&id=6fcd137c&scoped=true"
import script from "./Ticket_Lifecycle.vue?vue&type=script&lang=js"
export * from "./Ticket_Lifecycle.vue?vue&type=script&lang=js"

import "./Ticket_Lifecycle.vue?vue&type=style&index=0&id=6fcd137c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcd137c"]])

export default __exports__